<template>
  <div class="debug">
    <n-input-switch
      :label="$t('editor.debug.renderImageName')"
      :checked="debug.renderImageName"
      @change="handleDebugRenderImageNameChange" />
    <n-input-switch
      :label="$t('editor.debug.renderImageRect')"
      :checked="debug.renderImageRect"
      @change="handleDebugRenderImageRectChange" />
    <n-input-switch
      :label="$t('editor.debug.renderCurrentBone')"
      :checked="debug.renderCurrentBone"
      @change="handleDebugRenderCurrentBoneChange" />
    <n-input-switch
      :label="$t('editor.debug.renderBone')"
      :checked="debug.renderBone"
      @change="handleDebugRenderBoneChange" />
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState, mapMutations } from 'vuex'
import InputSwitch from '@/components/InputSwitch'

export default {
  components: {
    'n-input-switch': InputSwitch
  },
  computed: {
    ...mapState({
      debug: (state) => state.crop.data.debug
    })
  },
  methods: {
    ...mapMutations({
      setDebugOption: 'crop/setDebugOption'
    }),
    handleDebugRenderImageNameChange (e) {
      this.setDebugOption({ name: 'renderImageName', checked: e.target.checked })
    },
    handleDebugRenderImageRectChange (e) {
      this.setDebugOption({ name: 'renderImageRect', checked: e.target.checked })
    },
    handleDebugRenderCurrentBoneChange (e) {
      this.setDebugOption({ name: 'renderCurrentBone', checked: e.target.checked })
    },
    handleDebugRenderBoneChange (e) {
      this.setDebugOption({ name: 'renderBone', checked: e.target.checked })
    }
  }
}
</script>
